FD.Page = function () {
    'use strict';
    let $color;

    const numberFormatter = Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    const pomTemplate = $("#POM_SELECTED").html();
    const notify = new Notify();
    let isLoaded = false;

    function saveHistory() {
        const params = new URLSearchParams(document.location.search);
        const form = FD.Utility.getControlValuesByContainer("#FORM");
        const data = {
            widthInFeet: form.WidthInFeet,
            widthInInches: form.WidthInInches,
            lengthInFeet: form.LengthInFeet,
            lengthInInches: form.LengthInInches,
            selectedPalette: form.SelectedPalette,
            colorId: form.ColorId,
            productRegistryName: form.ProductRegistryName,
            hasBorder: $("#FORM input[type=checkbox][name$=HasBorder]").is(':checked')
        }
        if (params.get('back')) {
            data.back = params.get('back');
        }
        history.replaceState(null, '', window.location.pathname + '?' + decodeURIComponent($.param(data)).replaceAll("[]", ''));
    }

    function updateSquareFootage() {
        const widthInFeet = Number($("#Customization_WidthInFeet").val());
        const widthInInches = Number($("#Customization_WidthInInches").val());
        const totalWidthInFeet = widthInInches / 12.0 + widthInFeet;

        // determine if we need to set the length programmatically
        const $lengthInFeet = $("#Customization_LengthInFeet");
        const $lengthInInches = $("#Customization_LengthInInches");

        // calculate square footage and total lengths because we must validate them
        const lengthInFeet = Number($lengthInFeet.val());
        const lengthInInches = Number($lengthInInches.val());
        const totalLengthInFeet = lengthInInches / 12.0 + lengthInFeet;
        
        $("#Customization_SidesAtMost20Feet").val((totalWidthInFeet <= 20 ? 1 : 0) + (totalLengthInFeet <= 20 ? 1 : 0));
        $("#Customization_SideAtMost13Feet").val((totalWidthInFeet > 13 ? 1 : 0) + (totalLengthInFeet > 13 ? 1 : 0));
        $("#Customization_SideAtMost30Feet").val((totalWidthInFeet > 30 || totalLengthInFeet > 30) ? 2 : 0);
        $("#Customization_SquareFootage").val(totalWidthInFeet * totalLengthInFeet);
        
        if ($("#FORM").valid()) {
            $(".size-required-cart").addClass("d-none");
            return totalWidthInFeet * totalLengthInFeet
        }

        return 0;
    }

    function syncFields() {
        const data = $("#FORM").serializeArray().reduce((acc, { name, value }) => {
            acc[name] = value
            return acc
        }, {});

        $('[data-fd-sync-field').each(function () {
            const $this = $(this);
            const val = data[$this.attr('data-fd-sync-field')];
            if (val !== undefined) {
                if ($this.is('input')) {
                    $this.val(val);
                } else {
                    $this.text(val);
                }

            }
        });
    }

    function openDimensionsOverlay() {
        $('body').trigger('fd:toggle-set', ["dimensions", true]);
    }

    function calculateCost() {
        syncFields();
        $.fdAjax({
            url: FD.Page.calculateCostAction,
            params: $("#FORM").serialize(),
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            callback: (result) => $("[data-fd-cost]").text(numberFormatter.format(result.data))
        });
    }

    function updateCityState($zip, $form) {
        return App.updateCityStateFromZip($zip, $("input[name$=City]", $form), $("input[name$=State]", $form));
    }

    function submitInquiryForm(form) {

        const doSumbit = () => {
            const tradeStatus = $("[name$=TradeStatus]:checked", form).val();
            const valid = tradeStatus == "DesignerOrArchitect" || tradeStatus == "WorkingWithDesigner";

            if (form.valid() && valid) {
                $.fdAjax({
                    url: FD.Page.submitInquiryAction,
                    params: form.serialize(),
                    contentTypeHelper: "form",
                    callback: (result) => {

                        if (!result?.success) {
                            $('#SUBMIT_ERROR').html('Unable to send message.');
                            return;
                        }

                        $('#INQUIRY_FORM').toggleClass('hidden', true);
                        $('#INQUIRY_CONFIRMATION').toggleClass('hidden', false);

                        if (typeof dataLayer !== 'undefined') {
                            dataLayer.push({ 'event': 'inquiry-success' });
                        }
                    }
                });
            }
        }

        if (!form.valid()) {
            if ($("select[name$=Country]", form).val() == FD.Constant.unitedStatesCode) {
                updateCityState($("input[name$=ZipCode]", form), form).then(() => {
                    doSumbit();
                });
            }
        } else {
            doSumbit();
        }
    }

    function submitRequestASampleForm(form) {
        const doSumbit = () => {
            if (form.valid()) {
                $.fdAjax({
                    url: FD.Page.submitRequestASampleAction,
                    params: form.serialize(),
                    contentTypeHelper: "form",
                    callback: (result) => {

                        if (!result?.success) {
                            $('#SUBMIT_ERROR').html('Unable to send message.');
                            return;
                        }

                        $('#INQUIRY_FORM').toggleClass('hidden', true);
                        $('#INQUIRY_CONFIRMATION').toggleClass('hidden', false);

                        if (typeof dataLayer !== 'undefined') {
                            dataLayer.push({ 'event': 'sample-request-success' });
                        }
                    }
                });
            }
        }

        if (!form.valid()) {
            if ($("select[name$=Country]", form).val() == FD.Constant.unitedStatesCode) {
                updateCityState($("input[name$=ZipCode]", form), form).then(() => {
                    doSumbit();
                });
            }
        } else {
            doSumbit();
        }
    }

    function submitPomRequestForm(form) {

        const doSumbit = () => {
            if (form.valid()) {
                $.fdAjax({
                    url: FD.Page.submitPomFormAction,
                    params: form.serialize(),
                    contentTypeHelper: "form",
                    callback: (result) => {
                        if (!result?.success) {
                            $('#SUBMIT_ERROR').html('Unable to send message.');
                            return;
                        }

                        $('#NEW_POM_FORM').toggleClass('hidden', true);
                        $('#NEW_POM_FORM_CONFIRMATION').html(result.data.html).toggleClass('hidden', false);

                        if (typeof dataLayer !== 'undefined') {
                            dataLayer.push({ 'event': 'pom-request-success' });
                        }
                    }
                });
            }
        }

        if (!form.valid()) {
            if ($("select[name$=Country]", form).val() == FD.Constant.unitedStatesCode) {
                updateCityState($("input[name$=ZipCode]", form), form).then(() => {
                    doSumbit();
                });
            }
        } else {
            doSumbit();
        }
    }

    function setupPreview() {
        if ($('.palette-list').length) {
            $("#PREVIEW").on('load', finishSetup);
            if (!isLoaded) {
                // We shoudn't need to call there here, but some browsers don't properly trigger the event in some cases due to resource load order.
                $("#PREVIEW").prop('data', $("#PREVIEW").prop('data'));
            }
        }
    }

    function finishSetup() {
        const selectedPalette = +$("input[name$=SelectedPalette]").val();
        FD.Page.editPalette({ parentid: selectedPalette }, false);

        const params = new URLSearchParams(document.location.search);
        if (params.has('selectedPalette')) {
            // Apply custom colors form url
            if (params.get('colorId')) {
                const colors = params.get('colorId').indexOf(',') > -1 ? params.get('colorId').split(',') : params.getAll('colorId');
                if (colors.length) {
                    $(".color-visualizer-customization [name$=ColorId]").each((idx, item) => {
                        const $color = $(`.palette-item .palette[data-fd-parentid=${selectedPalette}] [data-color=${idx}]`);
                        const $selection = $(`.grid-palette .palette-color[data-fd-parentid=${colors[idx]}]`);

                        // Update top color and form values
                        $color.find('.palette-color').data({
                            colorId: colors[idx],
                            colorHex: $selection.data('fdValue'),
                            colorCode: $selection.data('code')
                        });
                        $color.find('.palette-color').css("--color", $selection.data('fdValue')).css("--border-color", $selection.css('--border-color'));
                    });
                }
            }

            const element = $(`.palette-item .palette[data-fd-parentid='${selectedPalette}'] .palette-color:first`);
            FD.Page.selectColor.call({ element });
        }
        FD.Page.applyPalette(selectedPalette, false);
        if (!isLoaded) {
            isLoaded = true;
            loadPreview();
        }

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const hilight = isSafari ? 'fill: #dedad6;' : 'filter: invert(15%);';

        const doc = $("#PREVIEW")[0].contentDocument;
        for (const rule of doc.styleSheets[0].cssRules) {
            if (rule.selectorText.includes('g:has') || !rule.style.fill) {
                break;
            }
            $(rule.selectorText, doc).on('click', function () {
                const className = `.${$(this).attr('class')}`;
                const color = $("input[name*=PaletteClasses]").filter((idx, item) => $(item).val() == className).data('color');
                $(`[data-color="${color}"] i`, '.palette-item .palette:visible').click();
            });
            doc.styleSheets[0].insertRule(`g:has(${rule.selectorText}:hover) ${rule.selectorText} { ${hilight} }`, doc.styleSheets[0].cssRules.length)
        }
        const hasBorder = $("#FORM input[type=checkbox][name$=HasBorder]").is(':checked');
        doc.styleSheets[0].insertRule(`#TextureMain { pointer-events: none; }`, doc.styleSheets[0].cssRules.length);
        doc.styleSheets[0].insertRule(`#TextureNoBorder { pointer-events: none;display: ${hasBorder ? 'none' : 'block'} }`, doc.styleSheets[0].cssRules.length);
        doc.styleSheets[0].insertRule(`#TextureBorder { pointer-events: none; display: ${!hasBorder ? 'none' : 'block'} }`, doc.styleSheets[0].cssRules.length);
    }

    function loadPreview() {
        const show = $('.product-image').is('.semi-custom-customize');
        if (isLoaded) {
            const selectedPalette = +$("input[name$=SelectedPalette]").val();
            FD.Page.applyPalette(selectedPalette, show);
        }
        $("#PREVIEW")
            .css('height', "600px")
            .css('height', "");
        if (show) {
            $("#PREVIEW")
                .parent().removeClass('d-none').end()
            setTimeout(() => {
                $("#PREVIEW")
                    .parent().removeClass('hide-preview')
                    .prev();
            }, 500);
        }
    }

    const page = {
        init: function () {
            setTimeout(() => {
                // This should never happen, but is being left here incase the setupPreview change that resets the data attribute is ever removed.
                if ($('.product-image').is('.semi-custom-customize') && !isLoaded) {
                    finishSetup();
                }
            }, 500);

            setupPreview();

            const params = new URLSearchParams(document.location.search);
            if (params.has('selectedPalette')) {
                if ($("#START_CUSTOMIZING").length) {
                    this.toggleControls();
                } else {
                    $("#LOGIN_START_CUSTOMIZING").click();
                }
            }

            this.sticky = new Sticky('[data-sticky]');
        },

        countryChanged: function (data) {
            const $form = this.element.closest('form');
            if (data.value == FD.Constant.unitedStatesCode) {
                updateCityState($("input[name$=ZipCode]", $form), $form);
            } else {
                $("input[name$=City]", $form).val('');
                $("input[name$=State]", $form).val('');
            }
            $("input[name$=City],input[name$=State]").prop('readonly', data.value == FD.Constant.unitedStatesCode);
            $("input[name$=ZipCode]").attr('type', data.value == FD.Constant.unitedStatesCode ? 'number' : 'text').blur();
        },

        zipCodeChanged: function () {
            const form = this.element.closest('form');
            if ($("select[name$=Country]", form).val() == FD.Constant.unitedStatesCode) {
                updateCityState(this.element, form);
            }
        },

        ignoreDimensionValidation: function () {

            /** @type {JQLite} */
            this.element.closest("form").validate().destroy();
            $("#Customization_WidthInFeet,#Customization_WidthInInches,#Customization_LengthInFeet,#Customization_LengthInInches, #Customization_SquareFootage, #Customization_SidesAtMost20Feet")
                .addClass("ignore-validators");
            $form.data("fdControl_form").rebuildValidate();
        },

        sizeUpdated: function () {
            updateSquareFootage();
            calculateCost();
            saveHistory();
        },

        /**
         * User wants to save a new customization to a project. First validate the form before opening the modal.
         * @param {any} xhr
         */
        openProjectModal: function (xhr) {
            FD.Utility.stopLadda.call(this);

            FD.Modal.openModal(xhr, {
                onCreate: function ($modal) {
                    $modal.find('img').attr('src', $('#PRODUCT_IMG').attr('src')); // add img on login screen
                    var url = window.location.href.replace(window.location.origin, '');
                    if (!url.includes('selectedPalette')) {
                        url += url.includes('?') ? '&selectedPalette=0' : '?selectedPalette=0';
                    }
                    $modal.find('[data-return-url]').val(url);

                    $('#AddToProject_Customization_LengthInFeet').val($('#Customization_LengthInFeet').val());
                    $('#AddToProject_Customization_LengthInInches').val($('#Customization_LengthInInches').val());
                    $('#AddToProject_Customization_WidthInFeet').val($('#Customization_WidthInFeet').val());
                    $('#AddToProject_Customization_WidthInInches').val($('#Customization_WidthInInches').val());

                    if ($(".color-visualizer-customization").is(":visible")) {
                        const form = FD.Utility.getControlValuesByContainer("#FORM");
                        const colors = $('.palette-item .palette:visible .palette-color').map((_, s) => $(s).data('colorHex')).toArray().join('|')
                        const data = {
                            colors: colors,
                            productId: form.ProductId,
                            hasBorder: $("#FORM input[type=checkbox][name$=HasBorder]").is(':checked'),
                            format: 'svg'
                        }

                        const url = FD.Page.colorVisualizerImageUrl + "?" + $.param(data).replaceAll("[]", '');
                        $modal.find('img').attr('src', url);
                    }
                    const $newProject = $modal.find('#newProject');
                    $modal.find('#project').on('change', function () {
                        $newProject.toggleClass("d-none", this.value > 0);
                    });

                    $(".color-visualizer-customization [name$=ColorId]").clone().appendTo('#PROJECT_FORM');
                    $("#FORM [name$=HasBorder]").clone().removeAttr('data-fd-control').appendTo('#PROJECT_FORM')
                }
            });
        },
        /**
         * User is adding the customization to a project and submitted their choice of project to save it to.
         * @param {any} data
         */
        saveToProject: function (data, e) {
            e.preventDefault();
            const element = e.target;
            const customizingElem = $('#AddToProject_Customization_IsCustomizing');
            if (customizingElem) {
                const isCustomizing = !$('.semi-custom').hasClass('d-none');
                customizingElem.val(isCustomizing);
            }

            const submit = () => {
                $.fdAjax({
                    url: FD.Page.saveToProjectAction,
                    params: $(element).serialize(),
                    contentTypeHelper: 'form',
                    callback: (result) => {
                        if (FD.Utility.getControlValuesByContainer(element).AddToQuote == 'true') {
                            const param = {
                                projectId: result.data.projectId,
                                customizationIds: result.data.id,
                            }
                            const href = FD.Page.downloadQuoteUrl + '?' + $.param(param);
                            const link = $('<a>').attr({ href, target: '_blank', id: 'DOWNLOAD_QUOTE_REMOVE' });
                            link.appendTo('body');
                            link[0].click();
                            link.remove();
                            FD.Modal.hideModal.call(element.closest('.modal'));
                        } else {
                            window.location = FD.Page.projectUrl.replace('0', result.data.projectId);
                        }
                    }
                });
            }

            if ($("#project").val() == "0") {
                if ($(element).valid()) {
                    const name = $('#newProject_Name').val();

                    $.fdAjax({
                        url: FD.Page.addProjectAction,
                        params: $(element).serialize(),
                        contentTypeHelper: "form",
                        callback: (result) => {
                            $("#project").append($(`<option value="${result.data}">${name}</option>`));
                            $("#project").val(result.data);
                            submit();
                        }
                    });
                }
            } else {
                submit();
            }
        },
        addOrUpdateCart: function (data, event) {
            if (updateSquareFootage() == 0) {
                $(".size-required-cart").removeClass("d-none");
                $("#Customization_WidthInFeet").focus();
                event?.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * There are a few buttons which submit this form that shouldn't enforce strict validation.
         * This function provides the ability to override validation.
         */
        submit: function () {

            /** @type {JQLite} */
            const $trigger = this.popTriggerElement();

            if (!this.valid() && $trigger.hasClass("ignore-validation")) {
                // allow the form to submit since the button that triggered the form specified it
                $(":input", this.element).addClass("ignore-validators");
                $(".field-validation-error").hide();

                setTimeout(() => $trigger.click());
            }
        },
        updateDimensions: function (data, e) {
            e.preventDefault();
            openDimensionsOverlay();
        },
        downloadTearSheet: function (data, e) {
            const id = +data.parentid;
            const queryString = id ? '' : window.location.search;
            const href = this.element.attr('href').split('?')[0] + queryString;
            this.element.attr('href', decodeURIComponent(href));
        },
        beforeDownloadQuote: function () {
            return FD.Page.addOrUpdateCart();
        },
        promptLogin: function (data, e) {
            e.preventDefault();
            $('#LOGIN').trigger('click');
        },
        toggleControls: function (data, e) {
            $('.semi-custom').removeClass('d-none');
            $('.semi-custom-block').addClass('d-none');
            $('.product-image').removeClass('semi-custom').addClass('semi-custom-customize');

            $("#START_CUSTOMIZING").addClass('d-none');
            FD.Page.sticky?.update();

            loadPreview();
        },
        submitInquiry: function (data, e) {
            e.preventDefault();
            submitInquiryForm(this.element);
        },
        submitPomForm: function (data, e) {
            e.preventDefault();
            submitPomRequestForm(this.element);
        },
        submitRequestASample: function (data, e) {
            e.preventDefault();
            submitRequestASampleForm(this.element);
        },

        editPalette: function (data, applyPalette = true) {
            $("input[name$=SelectedPalette]").val(data.parentid);
            $(".palette-item .palette").each(function () {
                $(this).toggleClass('d-none', $(this).data('fdParentid') != data.parentid);
                $(this).toggleClass('d-flex', $(this).data('fdParentid') == data.parentid);
                // Rest the palette colors.
                if ($(this).data('fdParentid') == data.parentid) {
                    $(this).find('.palette-color').each(function () {
                        const data = $(this).parent().data();
                        $(this).data(data);
                        $(this).css("--color", data.colorHex);
                        $(this).css("--border-color", data.borderColor);
                    });
                }
            });
            $(".palette-item").removeClass('d-none');

            const palette = $(`.palette-item .palette[data-fd-parentid='${data.parentid}'] .palette-color:first`);
            FD.Page.selectColor.call({ element: palette });
            if (applyPalette) {
                FD.Page.applyPalette(data.parentid);
            }

            $(`.palette-list .palette i.selected`).removeClass('selected');
            $(`.palette-list .palette[data-fd-parentid='${data.parentid}'] i`).addClass('selected');
        },
        selectColor: function () {
            const $selected = $(".selected-color");
            $color = this.element.parent();
            const silkPage = $('.grid-palette').data('all-pages') - 1;
            const isSilk = $(`.palette-picker .grid-palette [data-fd-parentid=${this.element.data("colorId")}]`).is(`.page-${silkPage}`);
            $selected.find('div').text(this.element.data("colorCode") + (isSilk ? " - SILK" : ""));
            $selected.find('i').css("--color", this.element.data("colorHex"));

            this.element.closest('.palette').find('.palette-color.selected').removeClass('selected');
            this.element.addClass('selected');

            $('.grid-palette .palette-color.selected').removeClass('selected');
            $(`.grid-palette .palette-color[data-code=${this.element.data("colorCode")}]`).addClass('selected');

            const includeSilk = this.element.data('include-silk-colors') == 'True';
            const pages = $('.grid-palette').data('all-pages') - (includeSilk ? 0 : 1);
            $('.grid-palette').data('pages', pages).attr('data-pages', pages);
            if ($('.grid-palette').data('page') == 3 && pages == 3) {
                $('.grid-palette').data('page', 0).attr('data-page', 0);
                this.element.closest(".product-details").find("[data-show-page]").addClass('visibility-hidden');
                this.element.closest(".product-details").find(`[data-show-page=0]`).removeClass('visibility-hidden');
            }
        },
        applyColor: function (data) {
            this.element.siblings('.selected').removeClass('selected');
            this.element.addClass('selected');

            // Update left "selected color"
            const $selected = $(".selected-color");
            const wasSilk = $selected.find('div').text().endsWith(" - SILK");
            const isSilk = $('.grid-palette').data('page') == $('.grid-palette').data('all-pages') - 1;
            $selected.find('div').text(this.element.data('code') + (isSilk ? " - SILK" : ""));
            $selected.find('.palette-color').css("--color", data.value);

            // Update top color and form values
            $color.find('.palette-color').data({
                colorId: data.parentid,
                colorHex: data.value,
                colorCode: this.element.data('code')
            });
            $color.find('.palette-color').css("--color", data.value).css("--border-color", this.element.css('--border-color'));

            FD.Page.applyPalette($color.closest('.palette').data('fdParentid'));
            if (isSilk != wasSilk) {
                calculateCost();
            }
        },
        applyPalette: function (palette, updateUrl = true) {
            const hasBorder = $("#FORM input[type=checkbox][name$=HasBorder]").is(':checked');
            // Update the form values
            $(".color-visualizer-customization [name$=ColorId]").each((_, item) => {
                const color = $(item).data('color');
                const colorid = $(`.palette-item .palette[data-fd-parentid=${palette}] [data-color=${color}] .palette-color`).data('colorId');
                $(item).val(colorid);
            })

            // Update the preview
            const classes = $(".color-visualizer-customization input[name*=PaletteClasses]").map((_, item) => $(item).val()).toArray();
            for (const rule of $("#PREVIEW")[0].contentDocument.styleSheets[0].cssRules) {
                if (rule.selectorText.includes('g:has')) {
                    continue;
                }
                if (rule.selectorText == '#TextureNoBorder') {
                    rule.style.display = !hasBorder ? 'block' : 'none';
                } else if (rule.selectorText == '#TextureBorder') {
                    rule.style.display = hasBorder ? 'block' : 'none';
                } else {
                    const color = $(`.palette-item .palette[data-fd-parentid=${palette}] [data-color=${classes.indexOf(rule.selectorText)}] .palette-color`).data('colorHex');
                    if (rule.style.fill) {
                        rule.style.fill = color;
                    }
                    if (classes.indexOf(rule.selectorText) == classes.length - 1) {
                        rule.style.display = hasBorder ? 'block' : 'none';
                    }
                }
            }
            if (updateUrl) {
                saveHistory();
            }

        },
        hasBorderUpdated: function (data) {
            const selectedPalette = +$("input[name$=SelectedPalette").val();
            $('.palette-item .palette').each(function () {
                $('.palette-colors > *:last-child', this)
                    .toggleClass('d-none', !data.value)
                    .toggleClass('d-flex', data.value);

            });
            if (!data.value && $color.index() == $(`.palette-item .palette[data-fd-parentid=${selectedPalette}] .palette-colors > *:last-child`).index()) {
                FD.Page.selectColor.call({ element: $color.prev().find('.palette-color') });
            }
            FD.Page.applyPalette(selectedPalette);
        },

        prevPage: function (data) {
            const grid = this.element.closest('.d-flex').find('.grid-palette');
            let page = grid.data('page');
            const pages = grid.data('pages');
            page = page == 0 ? pages - 1 : page - 1;
            grid.data('page', page).attr('data-page', page);
            this.element.closest(".product-details").find("[data-show-page]").addClass('visibility-hidden');
            this.element.closest(".product-details").find(`[data-show-page=${page}]`).removeClass('visibility-hidden');
        },
        nextPage: function (data) {
            const grid = this.element.closest('.d-flex').find('.grid-palette');
            let page = grid.data('page');
            const pages = grid.data('pages');
            page = page == pages - 1 ? 0 : page + 1;
            grid.data('page', page).attr('data-page', page);
            this.element.closest(".product-details").find("[data-show-page]").addClass('visibility-hidden');
            this.element.closest(".product-details").find(`[data-show-page=${page}]`).removeClass('visibility-hidden');
        },
        addPomSample: function (data) {
            if ($(`.pom-selections .pom-selection[data-fd-parentid=${data.parentid}]`).length) {
                // Item already seelcted.
                return;
            }

            if ($('.pom-selections .pom-selection').length == 6) {
                notify.alert("Each order is limited to six colors.");
                return;
            }

            const item = $(pomTemplate)
                .attr('data-fd-parentid', data.parentid)
                .find('input').val(data.parentid).end()
                .find('.palette-color').css('--color', data.value).css('--border-color', this.element.css('--border-color')).end()
                .find('.pom-color').text(this.element.data('code')).end();

            $('.pom-selections').append(item).enableControls();
            $("input[name$=ColorCount]").val($('.pom-selections .pom-selection').length);
        },
        removePomSample: function (data) {
            this.element.closest('.pom-selection').remove();
            $("input[name$=ColorCount]").val($('.pom-selections .pom-selection').length);
        },

    };

    return Object.assign({}, FD.Page, page);
}();